import "@/App.css";
import "@/styles/mobile-mode.css";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import { Toaster } from "@/components/ui/sonner";
import { CRMProvider } from "@/context/CRMContext";
import { FabricCatalogProvider } from "@/contexts/FabricCatalogContext";
import Navigation from "@/components/Navigation";
import AdminLayout from "@/components/AdminLayout";
import HomePage from "@/pages/HomePage";
import CollectionsPage from "@/pages/CollectionsPage";
import BookingPage from "@/pages/BookingPage";
import AboutPage from "@/pages/AboutPage";
import ContactPage from "@/pages/ContactPage";
import MeasurementsPage from "@/pages/MeasurementsPage";
import MeasurementFormPDF from "@/pages/MeasurementFormPDF";
import PolicyPage from "@/pages/PolicyPage";
import ManageAppointmentPage from "@/pages/ManageAppointmentPage";
import AdminPage from "@/pages/AdminPage";
import AdminPricingPage from "@/pages/AdminPricingPage";
import AdminAppointmentsPage from "@/pages/AdminAppointmentsPage";
import AdminMeasurementsPage from "@/pages/AdminMeasurementsPage";
import AdminCalendarPage from "@/pages/AdminCalendarPage";
import AdminAIAssistantPage from "@/pages/AdminAIAssistantPage";
import AdminShippingPage from "@/pages/AdminShippingPage";
import AdminCRMPage from "@/pages/AdminCRMPage";
import AdminAlterationsPage from "@/pages/AdminAlterationsPage";
import AdminTasksPage from "@/pages/AdminTasksPage";
import AdminOrderStatusPage from "@/pages/AdminOrderStatusPage";
import AdminInvoicePage from "@/pages/AdminInvoicePage";
import AdminEmailInboxPage from "@/pages/AdminEmailInboxPage";
import AdminSizeChartPage from "@/pages/AdminSizeChartPage";
import AdminMTMOrderPage from "@/pages/AdminMTMOrderPage";
import AdminMTMStylesPage from "@/pages/AdminMTMStylesPage";
import AdminMTMFabricPage from "@/pages/AdminMTMFabricPage";
import AdminMTMMeasurementsPage from "@/pages/AdminMTMMeasurementsPage";
import AdminMTMSubmitPage from "@/pages/AdminMTMSubmitPage";
import AdminUsersPage from "@/pages/AdminUsersPage";
import AdminRCCodeBookPage from "@/pages/AdminRCCodeBookPage";
import AdminPOSPage from "@/pages/AdminPOSPage";
import AdminAITailorPage from "@/pages/AdminAITailorPage";
import AdminSettingsPage from "@/pages/AdminSettingsPage";
import AdminQuickOrderPage from "@/pages/AdminQuickOrderPage";
import FactoryPortalPage from "@/pages/FactoryPortalPage";
import AdminOrderAuditPage from "@/pages/AdminOrderAuditPage";
import AdminPricingFabricsPage from "@/pages/AdminPricingFabricsPage";
import AdminMessagesPage from "@/pages/AdminMessagesPage";
import AdminCodeManagerPage from "@/pages/AdminCodeManagerPage";
import AIMeasurementPage from "@/pages/AIMeasurementPage";
import FAQPage from "@/pages/FAQPage";
import HowItWorksPage from "@/pages/HowItWorksPage";
import Footer from "@/components/Footer";

function App() {
  return (
    <div className="App min-h-screen bg-background">
      <div className="noise-overlay" />
      <BrowserRouter>
        <CRMProvider>
          <FabricCatalogProvider>
          <Navigation />
          <AdminLayout>
            <main>
              <Routes>
                <Route path="/" element={<HomePage />} />
                <Route path="/collections" element={<CollectionsPage />} />
                <Route path="/booking" element={<BookingPage />} />
                <Route path="/about" element={<AboutPage />} />
                <Route path="/contact" element={<ContactPage />} />
                <Route path="/measurements" element={<MeasurementsPage />} />
                <Route path="/measurement-form" element={<MeasurementFormPDF />} />
                <Route path="/policy" element={<PolicyPage />} />
                <Route path="/manage-appointment" element={<ManageAppointmentPage />} />
                <Route path="/admin" element={<AdminPage />} />
                <Route path="/admin/pricing" element={<AdminPricingPage />} />
                <Route path="/admin/appointments" element={<AdminAppointmentsPage />} />
                <Route path="/admin/measurements" element={<AdminMeasurementsPage />} />
                <Route path="/admin/calendar" element={<AdminCalendarPage />} />
                <Route path="/admin/ai-assistant" element={<AdminAIAssistantPage />} />
                <Route path="/admin/shipping" element={<AdminShippingPage />} />
                <Route path="/admin/crm" element={<AdminCRMPage />} />
                <Route path="/admin/alterations" element={<AdminAlterationsPage />} />
                <Route path="/admin/tasks" element={<AdminTasksPage />} />
                <Route path="/admin/orders" element={<AdminOrderStatusPage />} />
                <Route path="/admin/invoices" element={<AdminInvoicePage />} />
                <Route path="/admin/inbox" element={<AdminEmailInboxPage />} />
                <Route path="/admin/size-chart" element={<AdminSizeChartPage />} />
                <Route path="/admin/mtm-order" element={<AdminMTMOrderPage />} />
                <Route path="/admin/mtm-styles" element={<AdminMTMStylesPage />} />
                <Route path="/admin/mtm-fabric" element={<AdminMTMFabricPage />} />
                <Route path="/admin/mtm-measurements" element={<AdminMTMMeasurementsPage />} />
                <Route path="/admin/mtm-submit" element={<AdminMTMSubmitPage />} />
                <Route path="/admin/users" element={<AdminUsersPage />} />
                <Route path="/admin/price-list" element={<AdminPricingFabricsPage />} />
                <Route path="/admin/code-book" element={<AdminRCCodeBookPage />} />
                <Route path="/admin/code-manager" element={<AdminCodeManagerPage />} />
                <Route path="/admin/pos" element={<AdminPOSPage />} />
                <Route path="/admin/ai-tailor" element={<AdminAITailorPage />} />
                <Route path="/admin/settings" element={<AdminSettingsPage />} />
                <Route path="/admin/quick-order" element={<AdminQuickOrderPage />} />
                <Route path="/admin/rcmtm-portal" element={<FactoryPortalPage portalKey="rcmtm" />} />
                <Route path="/admin/mx-portal" element={<FactoryPortalPage portalKey="mx" />} />
                <Route path="/admin/order-audit" element={<AdminOrderAuditPage />} />
                <Route path="/admin/fabric-management" element={<AdminPricingFabricsPage />} />
                <Route path="/admin/pricing-fabrics" element={<AdminPricingFabricsPage />} />
                <Route path="/admin/messages" element={<AdminMessagesPage />} />
                <Route path="/ai-measurement" element={<AIMeasurementPage />} />
                <Route path="/faq" element={<FAQPage />} />
                <Route path="/how-it-works" element={<HowItWorksPage />} />
              </Routes>
            </main>
          </AdminLayout>
          <Footer />
          <Toaster position="bottom-right" />
          </FabricCatalogProvider>
        </CRMProvider>
      </BrowserRouter>
    </div>
  );
}

export default App;
